import { Box, ButtonBase, Stack, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";

import { CustomersType } from "api/customers/types";
import UserAvatar from "components/UserAvatar/UserAvatar";

const CreditEvaluationCustomer = ({
  customer,
}: {
  customer?: CustomersType;
}) => {
  const history = useHistory();

  return (
    <Stack
      onClick={() => history.push(`/customers/${customer?._id}`)}
      component={ButtonBase}
      sx={{ px: 1 }}
      direction={{ xs: "column", sm: "row" }}
      alignItems={{ xs: "flex-start", sm: "center" }}
      spacing={1}
    >
      <UserAvatar
        userName={
          customer ? `${customer?.firstName} ${customer?.lastName}` : "-"
        }
      />
      <Box ml={{ xs: 0, sm: 2 }}>
        <Typography
          variant="h4"
          textAlign="left"
          fontWeight="bold"
          mb={0.5}
          sx={{ fontSize: { xs: 16, sm: 20 } }}
        >
          {customer?.firstName} {customer?.lastName}
        </Typography>
        <Typography
          mb={0.5}
          sx={{
            color: "primary.main",
            fontSize: { xs: 13, sm: 16 },
            wordBreak: "break-all",
          }}
        >
          {customer?.email}
        </Typography>
      </Box>
    </Stack>
  );
};

export default CreditEvaluationCustomer;
